import { FC } from 'react';

import CenteredCircularProgress from 'components/page/CenteredCircularProgress';

export const Fallback: FC = () => {
  return <CenteredCircularProgress />;
};
